import i18next from 'i18next';

import cgvFR from "../documents/CGV_FR.pdf";
import cgvEN from "../documents/CGV_EN.pdf";
import cvbe from "../documents/SGS Conditions Generales Belges d Expedition BE2024.pdf";

export default () => {

    const language = i18next.language;

    const pdfFile = language === "fr" ? cgvFR : cgvEN;

    const isMobile = window.innerWidth <= 768;

    return (
        <div className="page">
            <div className="pillow"></div>
            <div className="condition _1">
                <div className="left-flex">
                    <a
                        className="btn download-btn"
                        href={pdfFile}
                        download>
                        {i18next.t("download_btn_1")}
                    </a>

                    <a
                        className="btn download-btn"
                        href={cvbe}
                        download>
                        {i18next.t("download_btn_2")}
                    </a>

                    {
                        !isMobile && (
                            <iframe
                                className="pdf-viewer"
                                src={`${pdfFile}#view=FitH`}
                                title="PDF Viewer"
                            />
                        )
                    }
                </div>

                <div className="right-flex">
                    <h1>{i18next.t("condition_gen")}</h1>
                    <p dangerouslySetInnerHTML={{__html: i18next.t("condition_desc")}}></p>
                </div>

            </div>
        </div>
    );
};